import { Component, Input } from '@angular/core';

@Component({
  selector: 'section-row',
  template: `    
    <div class="row bg-6AC5FF tableHeader">
      <div class="col-xs-8  col-sm-4 p-0">
        <p class="fz-18 m-0 p-5">{{sectionRowLabel}}
          <span *ngIf="!sectionRowOpen" class="dropup"><span class="caret"></span></span>
          <span *ngIf="sectionRowOpen"  class="caret"></span></p>
      </div>
      
      <div class="col-xs-4 col-sm-8">
        <div class="row">
        
        <div *ngFor="let row of sectionRowData | mobile:isMobile:columnHeader; let i = index">        
            <div *ngIf="i === 0 " 
                 [ngClass]="{'col-md-offset-1': sectionRowData?.length === 5,
                             'col-md-offset-3': sectionRowData?.length === 4,
                             'col-md-offset-5': sectionRowData?.length === 3}"
                 class="col-xs-12 col-md-2 ta-c ">
              <div class="pt-5">
                <data-cell [cellValues]="row.value" class="header-values-white"></data-cell>
              </div>
            </div>
            <div *ngIf="i !== 0" class="col-xs-12 col-md-2 ta-c ">
              <div class="pt-5">
                <data-cell [cellValues]="row.value" class="header-values-white"></data-cell>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class SectionRowComponent {
  @Input() sectionRowLabel;
  @Input() sectionRowData;
  @Input() sectionRowOpen;
  @Input() isMobile;
  @Input() columnHeader;
}



// WEBPACK FOOTER //
// ./src/app/t8-utl-per-fin/components-utl-per-fin/section-row/section-row.component.ts